// Import dependencies
import React from 'react';
import PropTypes from 'prop-types';

class Card extends React.Component {
  render() {
    const {
      title, description, images, url,
    } = this.props;

    const image = images.length > 0 ? images[0].url : null;

    return (
      <div className="c-card  c-card--small js-react-animate">
        <a className="c-card__link" href={url}>
          <div className="c-card__inner">
            {image && (
              <figure className="c-image">
                <div className="c-image__container">
                  <div className="c-image__background js-react-lazy" data-src={image}>
                    <picture>
                      <img className="js-lazy" data-src={image} alt="" />
                    </picture>
                  </div>
                </div>
              </figure>
            )}
          </div>

          <div className="c-card__content">
            <h4 className="c-card__title"><span>{title}</span></h4>
            <p className="c-card__copy">{description}</p>
            {/* todo: meta/date? */}
          </div>
        </a>
      </div>
    );
  }
}

Card.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string,
  })).isRequired,
};
// contentCategory: []
// date: "2020-04-16T14:00:00+00:00"

export default Card;
